<div class="row w-100">
    <form [formGroup]="settingsForm">
        <div>
            <h5>{{ 'KeyCloak.Settings.OpenIdSettings' | localize }}</h5>
        </div>

        <div class="row w-100">

            <!-- SubDomain -->
            <div class=" w-100 mt-3 mb-2 d-flex justify-content-start gap-3">
                <div class="w-100">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Subdomain</mat-label>
                        <input matInput required formControlName="subDomain">
                    </mat-form-field>
                </div>
                <div>
                    <label class="mt-1">{{ settingsForm.value['subDomain'] ? 'https://www.' + settingsForm.value['subDomain'] + '.bilgebot.ai' : 'https://www.example.bilgebot.ai' }}</label>
                </div>
            </div>


            <!-- Authorization URL -->
            <div class="w-100 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'KeyCloak.Settings.AuthorizationUrl' | localize }}</mat-label>
                    <input matInput formControlName="authorizationUrl" required
                           placeholder="{{ 'KeyCloak.Settings.AuthorizationUrlPlaceholder' | localize }}"
                           >
                </mat-form-field>
            </div>

            <!-- Token URL -->
            <div class="w-100 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'KeyCloak.Settings.TokenUrl' | localize }}</mat-label>
                    <input matInput formControlName="tokenUrl" required
                           placeholder="{{ 'KeyCloak.Settings.TokenUrlPlaceholder' | localize }}"
                           >
                </mat-form-field>
            </div>

            <!-- Logout URL -->
            <div class="w-100 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'KeyCloak.Settings.LogoutUrl' | localize }}</mat-label>
                    <input matInput formControlName="logoutUrl" required
                           placeholder="{{ 'KeyCloak.Settings.LogoutUrlPlaceholder' | localize }}"
                           >
                </mat-form-field>
            </div>

            <!-- User Info URL -->
            <div class="w-100 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'KeyCloak.Settings.UserInfoUrl' | localize }}</mat-label>
                    <input matInput formControlName="userInfoUrl" required
                           placeholder="{{ 'KeyCloak.Settings.UserInfoUrlPlaceholder' | localize }}"
                           >
                </mat-form-field>
            </div>

            <!-- Issuer -->
            <div class="w-100 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'KeyCloak.Settings.Issuer' | localize }}</mat-label>
                    <input matInput formControlName="issuer" required
                           placeholder="{{ 'KeyCloak.Settings.IssuerPlaceholder' | localize }}"
                           >
                </mat-form-field>
            </div>
            <div class="w-100 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'KeyCloak.Settings.JwksUrl' | localize }}
                        <span class="required-field"></span>
                    </mat-label>
                    <input matInput formControlName="JwksUrl" required
                           placeholder="{{ 'KeyCloak.Settings.JwksUrlPlaceholder' | localize }}"
                           >
                </mat-form-field>
            </div>
            <div class="d-flex w-100 mb-2 gap-3">
                <!-- Client ID -->
                <div class="w-100 ">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>
                            {{ 'KeyCloak.Settings.ClientId' | localize }}
                        </mat-label>
                        <input matInput formControlName="ClientId" required >
                    </mat-form-field>
                </div>
                <!-- Client Secret -->
                <div class="w-100 ">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>
                            {{ 'KeyCloak.Settings.ClientSecret' | localize }}
                        </mat-label>
                        <input matInput formControlName="ClientSecret" required >
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Form actions -->
        <div class="d-flex justify-content-start gap-2 mt-4">
            <button mat-raised-button color="primary" (click)="onSave()" [disabled]="loading">
                <span *ngIf="!loading">{{ 'KeyCloak.Actions.Save' | localize }}</span>
                <span *ngIf="loading">{{ 'KeyCloak.Actions.Saving' | localize }}</span>
                <mat-spinner *ngIf="loading" diameter="20" class="ms-2"></mat-spinner>
            </button>
            <button mat-button color="warn" (click)="onRevert()" [disabled]="loading">
                {{ 'KeyCloak.Actions.Revert' | localize }}
            </button>
        </div>
    </form>
</div>
